export default String.raw`
{% if page.QueryString contains 'executed-complaint-details' -%}
	{% assign tab = 'executed-complaints' -%}
	{% assign pageQueryName = customer-profile.ComplaintsExecuted.PageQueryGET -%}
{% else -%}
	{% assign tab = 'active-complaints' -%}
	{% assign pageQueryName = customer-profile.ComplaintsActive.PageQueryGET -%}
{% endif -%}

{% include 'partials/common/date-format.html' -%}
{% assign complaint = customer-profile.Complaint -%}
{% assign complaintString = customer-profile.ComplaintQueryGET -%}
{% assign orderString = customer-profile.OrderQueryGET -%}
{% assign queries = page.QueryString | Split: '&' -%}
{% for query in queries -%}
	{% if query contains 'page=' -%}
		{% assign pageQueryNo = query | Split: '=' | Last -%}
		{% break -%}
	{% else -%}
		{% assign pageQueryNo = 1 -%}
	{% endif -%}
{% endfor -%}

{% if complaint.Type == 0 -%}
	{% assign details = translations.Prf_OrderReturn -%}
	{% assign cancel = translations.ReturnCancel -%}
	{% assign cancelSuccess = translations.ReturnCancelled -%}
	{% assign includeId = 2 -%}
{% else -%}
	{% assign details = translations.Complaint -%}
	{% assign cancel = translations.ComplaintCancel -%}
	{% assign cancelSuccess = translations.ComplaintCancelled -%}
	{% assign includeId = 1 -%}
{% endif -%}

<div class="customer-submenu">
	<div class="customer-submenu__header submenu-header">
		<div class="navigation-header">
			<button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/complaints/complaints.html" data-url="{{ page.Url }}?tab={{tab}}">
				<svg aria-hidden="true" width="24" height="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			{{ details }} {{ complaint.ComplaintId }}
		</div>
		<div class="options submenu">
			<button class="pure-button open-dropdown-js">
				{{ translations.Options }}
				<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			<div class="dropdown dropdown-js hidden-js {% if page.QueryString contains 'active-complaint-details' and complaint.Status == 0 -%} header-options {% endif -%}">
				{% capture complaintReportHref -%}{% include 'partials/common/user-link.html', userLink: complaint.ReportUrl -%}{% endcapture -%}
				<a class="pure-button" aria-label="{{ translations.Print }}"  href="{{ complaintReportHref }}" target="_blank" rel="noopener noreferrer">{{ translations.Print }}</a>
			</div>
			{% if page.QueryString contains 'active-complaint-details' and complaint.Status == 0 -%}
			<div class="form-js form-into-data-js" data-success="{{ cancelSuccess }}">
				<input type="hidden" name="__action" value="Order/ComplaintCancel" >
				<input type="hidden" name="complaintId" value="{{ complaint.ComplaintId }}" >
				<button class="secondary-action-button parent-container-reload-js cancel-complaint-js" data-template="partials/customer-profile/complaints/complaints.html" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=executed-complaints">
				{{ cancel }}
				</button>
			</div>
			{% endif -%}
		</div>
	</div>
	<div class="order-details not-expandable">
		<div class="order-details__row">
			<div class="order-details-item {% if complaint.Status == 3 -%} executed {% elseif complaint.Status == 4 -%} canceled {% endif -%}">
				<div class="title">{{ translations.Status }}</div>
				<span>{{ complaint.StatusText | Capitalize }}</span>
			</div>
			{% unless complaint.ModifiedDate == null -%}
			<div class="order-details-item">
				<div class="title">{{ translations.ModificationDate }}</div>
				<span>{{ complaint.ModifiedDate | Date:dateFormat }}</span>
			</div>
			{% endunless -%}
			<div class="order-details-item">
				<div class="title">{{ translations.BuyDate }}</div>
				<span>{{ complaint.CreatedDate | Date:dateFormat }}</span>
			</div>
			<div class="order-details-item">
				<div class="title">{{ translations.PurchaseDocument }}</div>
				<span>{{ complaint.OrderId }}</span>
					<span class="pure-button load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ complaint.OrderId }}" data-url="{{ page.Url }}?{{ orderString | H }}={{ complaint.OrderId }}&deeper-lvl&tab=order-details" data-template="partials/customer-profile/orders/order-details.html">
						{{ translations.DocumentDetails }}
					</span>
				
			</div>
		</div>
	</div>

	{% assign complaintsSize = customer-profile.Complaint.Attachments | Size -%}
	{% if config.Complaints.AttachmentsEnabled and complaintsSize > 0 -%}
	<div class="attachements-container">
		<div class="title">{{ translations.Attachements }}</div>
		<div class="attachements">
		{% for file in customer-profile.Complaint.Attachments -%}
			{% assign type = file.Name | Split: '.' | Last | Downcase -%}
			{% if type == "jfif" or type == "jpe" or type == "jpeg" or type == "jpg" -%}
				{% assign icon = 'file-image' -%}
			{% elseif type == "csv" -%}
				{% assign icon = 'file-csv' -%}
			{% elseif type == "docx" or type == "odt" or type == "doc" -%}
				{% assign icon = 'file-word' -%}
			{% elseif type == "xlsx" or type == "ods" or type == "xls" -%}
				{% assign icon = 'file-spreadsheet' -%}
			{% elseif type == "zip" or type == "rar" or type == "7zip" -%}
				{% assign icon = 'file-archive' -%}
			{% elseif type == "pdf" -%}
				{% assign icon = 'file-pdf' -%}
			{% elseif type == "txt" -%}
        		{% assign icon = 'file-alt' -%}
			{% else -%}
        		{% assign icon = 'file' -%}
			{% endif -%}
			<div class="file-container file-container-js">
				{% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
				<a href="{{ fileHref }}">				
					<svg height="24" width="24" class="svgIcon">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{icon}}-{{settings.iconStyle}}"></use>
					</svg> 
					<span>{{ file.Name }}</span>
				</a>
			</div>
		{% endfor -%}
		</div>
	</div>
	{% endif -%}
	
	<div class="order-products-list-js">
		<div class="eshop__table-container products products-table-js">
			<table>
				<colgroup>
					<col style="width:700px">
					<col style="width:90px">
					<col style="width:250px">
				</colgroup>
				<thead>
					<tr class="products-table-header-js">
						<th class="id">
							{{translations.Product}}
						</th>
						<th>
							{{translations.Quantity}}
						</th>
						<th>
							{{translations.ComplaintCause}}
						</th>
						<th>
							{{translations.Request}}
						</th>
					</tr>  
				</thead>      
				<tbody> 
					<tr class="row expandable-mechanism-container-js cart-product-container-js" data-product-no="{{product.No}}">
						<td class="id">
								{% if complaint.Url -%}
									<a class="product-cell" href="{{ page.BaseHref }}{{ complaint.Url }}">
								{% endif -%}
										<div class="image">
											{% if complaint.ImageId != -1 or complaint.Image != null -%} {{ complaint | Img: 'thumb' }} {% else -%} <svg width="40" height="40"><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use></svg> {% endif -%}
										</div>
										<div class="product-info">
											<span class="product-name">
												{{ complaint.NameNoHtml }}
											</span>
											{% if config.Products.ShowCode and complaint.Code != "" -%}
												<span class="product-code">
													{{complaint.Code}}
												</span>
											{% endif -%}
										</div>
								{% if complaint.Url -%}
									</a>
								{% endif -%}
						</td>
						<td>
							<span>
								{% if config.Products.DecimalUnits -%}
									{{complaint.Quantity}}
								{% else -%}
									{{ complaint.Quantity | Normalize }}
								{% endif -%}
							</span>
							<span>
								{{complaint.Unit}}
							</span>
						</td>
						<td>
							{{complaint.Defect}}
						</td>
						<td>
							{{complaint.Request}}
						</td>
					</tr>
					<tr>
						<td class="id">{{translations.ItemsQuantity}}: 1</td>
					</tr>
				</tbody> 
			</table>
		</div>
	</div>

	{% if complaint.DefectDescription != "" -%}
	<div class="order-details-item complaint-notice">
		<div class="title">{{ translations.Remarks }}</div>
		<span>{{ complaint.DefectDescription != "" }}</span>
	</div>
	{% endif -%}

	{% if complaint.Description != "" -%}
	<div class="order-details-item complaint-notice">
		<div class="title">{{ translations.Remarks }}</div>
		<span>
			{% assign descriptionLength = complaint.Description | Size | Minus: 2 -%}
			{% assign description = complaint.Description | Slice: 0, descriptionLength | Split: ';' -%}
			{% for attribute in description -%}
				{{ attribute }}
			{% endfor -%}
		</span>
	</div>
	{% endif -%}
	
	{% if complaint.Response != "" -%}
	<div class="order-details-item complaint-notice">
		<div class="title">{{ translations.Remarks }} {{ translations.RangeFrom | Downcase }} {{ translations.SellerGenitive }}</div>
		<span>{{ complaint.Response }}</span>
	</div>
	{% endif -%}

	{% if page.QueryString contains 'active-complaint-details' -%}
		{% include 'partials/common/confirmation-popup.html' with includeId -%}
	{% endif -%}
</div>
`